<template>
  <div class="rounded shadow-xs w-full mx-auto" @click.stop>
    <div class="rounded shadow-lg bg-white overflow-hidden divide-y">
      <div class="h-10 bg-white pl-4">
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <h1 class="text-sm">
              {{ title }}
            </h1>
          </div>
          <div class="flex-none">
            <button
              class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
              @click="$emit('close')"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                <path
                  d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                  4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                  4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                  5.636z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="p-4">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VDialog',
  props: {
    title: {
      type: String,
      default: 'Title',
    },
  },
};
</script>
